// extracted by mini-css-extract-plugin
module.exports = {"session":"agenda-brf-aag_session__5SZuw","sessionHeader":"agenda-brf-aag_sessionHeader__uPqYh","sessionContent":"agenda-brf-aag_sessionContent__h_ia3"};